import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { Button, Divider, colors } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

type Props = {}

    const mock = {
        account: {
        title: '입회 및 수업 문의',
        subtitle: '입회 및 수업 관련 자주 묻는 질문 입니다.',
        items: [
            {
                title: '참여 가능한 연령대가 어떻게 되나요?',
                updated: 'test',
            },
            {
                title: '지역 내 어느 지역까지 차량 운행이 가능한가요?',
                updated: 'test',
            },
            {
                title: '수업에 필요한 준비물은 있나요?',
                updated: 'test',
            },
            {
                title: '수업에 참여하지 못한다면 보강은 어떻게 되나요?',
                updated: 'test',
            },
            {
                title: '등록비 결제 방식은 어떻게 되나요?',
                updated: 'test',
            },
            {
                title: '수업 시간 진행은 어떤 구성으로 되어 있나요?',
                updated: 'test',
            },
        ],
        },
        organizations: {
        title: '선수반 문의',
        subtitle: '선수반 관련 자주 묻는 질문 입니다.',
        items: [
            {
            title: '훈련 프로그램이 어떻게 되나요?',
            updated: 'desc',
            },
            {
            title: 'test',
            updated: 'desc',
            },
            {
            title: 'test',
            updated: 'desc',
            },
            {
            title: 'test',
            updated: 'desc',
            },
            {
                title: 'test',
                updated: 'desc',
            },
            {
            title: 'test',
            updated: 'desc',
            },
        ],
        },
    };
    
const HelpQs = (props: Props) => {

    const renderFaqBox = (title = '', subtitle = '') => (
        <Box
          component={Card}
          variant={'outlined'}
          bgcolor={'transparent'}
          sx={{
            cursor: 'pointer',
            '&:hover': {
              boxShadow: 2,
            },
          }}
        >
            <Box
                component={Accordion}
                flexDirection={{ xs: 'column', sm: 'row' }}
                justifyContent={{ sm: 'space-between' }}
                alignItems={{ sm: 'center' }}
            >
                <Box
                    component={AccordionSummary}
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    sx={{ height: '70px' }}
                    >
                    <Typography fontWeight={600}>{title}</Typography>
                    </Box>
                    <Divider />
                    <AccordionDetails>
                    <Typography color="text.secondary">{subtitle}</Typography>
                    </AccordionDetails>
                </Box>
        </Box>
      );

    return (
        <>
            <Box padding={7}>
                <Grid container spacing={4} sx={{  }}>
                    <Grid item xs={12} md={12}>
                        <Typography sx={{ textAlign: 'center', fontSize: '2em', fontWeight: 600, mt: -10 }}>
                            자주 묻는 질문
                        </Typography>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Box marginBottom={2}>
                            <Box
                            component={Avatar}
                            bgcolor={colors.amber[100]}
                            color={colors.amber[900]}
                            marginBottom={1}
                            width={60}
                            height={60}
                            >
                            <Box
                                component={'svg'}
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                width={24}
                                height={24}
                            >
                                <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
                                />
                            </Box>
                            </Box>
                            <Typography variant={'h6'} fontWeight={700} gutterBottom>
                            {mock.account.title}
                            </Typography>
                            <Typography color={'text.secondary'}>
                            {mock.account.subtitle}
                            </Typography>
                        </Box>
                    <Grid container spacing={2}>
                        {mock.account.items.map((item, index) => (
                        <Grid item xs={12} key={index}>
                            {renderFaqBox(item.title, `${item.updated}`)}
                        </Grid>
                        ))}
                    </Grid>
                    </Grid>

                    <Grid item xs={12} md={6} sx={{ marginTop: 0 }}>
                    <Box marginBottom={2}>
                        <Box
                        component={Avatar}
                        bgcolor={colors.red[100]}
                        color={colors.red[900]}
                        marginBottom={1}
                        width={60}
                        height={60}
                        >
                        <Box
                            component={'svg'}
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            width={24}
                            height={24}
                        >
                            <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z"
                            />
                        </Box>
                        </Box>
                        <Typography variant={'h6'} fontWeight={700} gutterBottom>
                        {mock.organizations.title}
                        </Typography>
                        <Typography color={'text.secondary'}>
                        {mock.organizations.subtitle}
                        </Typography>
                    </Box>
                    <Grid container spacing={2}>
                        {mock.organizations.items.map((item, index) => (
                        <Grid item xs={12} key={index}>
                            {renderFaqBox(item.title, `${item.updated}`)}
                        </Grid>
                        ))}
                    </Grid>
                    </Grid>

                </Grid>
            </Box>
        </>
    )
}

export default HelpQs